import Image from 'next/image';
import { useEffect, useRef } from 'react';
import { assetPath } from 'sly/lib/path';
import Heading from 'sly/system/Heading';

const logos = [
  {
    src: assetPath('uploads/react-assets/providers/image 416.png'),
    alt: 'Atria logo',
    width: 101.875,
    height: 60,
  },
  {
    src: assetPath('uploads/react-assets/providers/image 417.png'),
    alt: 'Civitas logo',
    width: 134,
    height: 41,
  },
  {
    src: assetPath('uploads/react-assets/providers/image 423.png'),
    alt: 'Frontier Logo',
    width: 181,
    height: 40,
  },
  {
    src: assetPath('uploads/react-assets/providers/image 426.png'),
    alt: 'Legend logo',
    width: 124.8,
    height: 40,
  },
  {
    src: assetPath('uploads/react-assets/providers/image 327.png'),
    alt: 'Bookdale logo',
    width: 169,
    height: 38,
  },
  {
    src: assetPath('uploads/react-assets/providers/image 419.png'),
    alt: 'Cogir logo',
    width: 93.7,
    height: 58,
  },
  {
    src: assetPath(
      'uploads/react-assets/providers/a5b46a4b96a5c28ab85facd1f5ffb7f3 (1).png'
    ),
    alt: 'Inspirit logo',
    width: 169.9,
    height: 42,
  },
  {
    src: assetPath(
      'uploads/react-assets/providers/2157c9903599d0344dcae3944d4fb170.png'
    ),
    alt: 'mbk logo',
    width: 137,
    height: 52,
  },
  {
    src: assetPath(
      'uploads/react-assets/providers/596100030482458297104112e02f8bbd.png'
    ),
    alt: 'belmont logo',
    width: 143,
    height: 44,
  },
  {
    src: assetPath(
      'uploads/react-assets/providers/789f6820084eedb487bfcf6588219505.png'
    ),
    alt: 'experience logo',
    width: 177,
    height: 42,
  },
  {
    src: assetPath(
      'uploads/react-assets/providers/7d10e2cc2dd3852a5d99c232f4a1fd89.png'
    ),
    alt: 'integral logo',
    width: 173,
    height: 50,
  },
  {
    src: assetPath(
      'uploads/react-assets/providers/bfe5b0942152257cdbbbb58d7fbe0009.png'
    ),
    alt: 'sunrise logo',
    width: 88,
    height: 50,
  },
  {
    src: assetPath(
      'uploads/react-assets/providers/5b396e3f6f7cb9bf2f9eab5df969f248.png'
    ),
    alt: 'wellquest logo',
    width: 144,
    height: 50,
  },
];

export default function PartnersCommunitiesThreePoints() {
  const scrollContainerRef = useRef<HTMLDivElement>(null);
  const scrollSpeed = 1;
  const directionRef = useRef(1);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    const scrollContainer = scrollContainerRef.current;

    if (!scrollContainer) return;

    const maxScrollLeft =
      scrollContainer.scrollWidth - scrollContainer.clientWidth;

    let animationFrameId: number;

    const scroll = () => {
      if (scrollContainer.scrollLeft >= maxScrollLeft) {
        timeoutRef.current = setTimeout(() => {
          directionRef.current = -1;
        }, 3000);
      } else if (scrollContainer.scrollLeft <= 0) {
        timeoutRef.current = setTimeout(() => {
          directionRef.current = 1;
        }, 3000);
      }

      scrollContainer.scrollLeft += scrollSpeed * directionRef.current;

      animationFrameId = requestAnimationFrame(scroll);
    };

    timeoutRef.current = setTimeout(() => {
      scroll();
    }, 3000);

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
      cancelAnimationFrame(animationFrameId);
    };
  }, []);

  return (
    <main className='flex flex-col gap-6 self-stretch pt-12 pb-6'>
      <Heading as='h2' font='font-t-m' className='flex justify-center'>
        Trusted by top providers
      </Heading>
      <article
        className='scroll-container flex items-center justify-start gap-4 py-6 pt-6'
        ref={scrollContainerRef}
      >
        {logos.map((logo, index) => (
          <div
            key={index}
            className='flex h-16 w-52 flex-shrink-0 items-center justify-center rounded-lg'
          >
            <Image
              src={logo.src}
              alt={logo.alt}
              loader={({ src }) => src}
              width={logo.width}
              height={logo.height}
              layout='fixed'
            />
          </div>
        ))}
      </article>
    </main>
  );
}
